<div class="filter-container">
    <div class="filter-header">
        <h2>{{ 'DETAILS.FILTER_TITLE' | translate }}</h2>
    </div>
    <div class="filter-content">
        <mat-checkbox class="recommendation-checkbox" [(ngModel)]="showOnlyGood">
            {{ 'DETAILS.FILTER_ONLY_RECOMMENDED' | translate }}
        </mat-checkbox>
    </div>

    <div class="filter-buttons">
        <button
                (click)="closeFilterDialog(false)"
                class="cancel action-button"
                mat-button>
            {{ 'GENERAL.CANCEL' | translate }}
        </button>

        <button
                (click)="closeFilterDialog(true)"
                class="apply action-button"
                mat-flat-button>
            {{ 'GENERAL.APPLY' | translate }}
        </button>
    </div>
</div>
